export default __webpack_public_path__ + "static/media/outline-arrow-down.1ff4852c.svg";